// propertydetail.js
//
// detail_show / project_detail_show:
//   [] or missing  → ENABLED for all categories (default)
//   [22, 24, ...]  → enabled only for those category ids
//
// Opt-in fields (address, address_details):
//   [] or missing  → DISABLED for all categories
//   [22, 24, ...]  → enabled only for those category ids
//
// card_land_show:
//   []             → not shown on listing card land chip (opt-in)
//   [22, ...]      → show this area value on card for those categories
//
// land_type_show / project_land_type_show:
//   [] or missing  → Land Type dropdown ENABLED for all categories (default)
//   [22, 24, ...]  → dropdown enabled only for those category ids
//   category omitted → hide dropdown; show the land type saved on the property
//
// Land Area fields use Land Types (sq-ft, cent, …) from /landtype —
// not a separate land_area_cent detail field.

const propertydetail = [

  // ── Land Area Details ─────────────────────────────────────────

  {
    id: 1,
    label: "Plot Area",
    field: "plot_area",
    unit: "sqft",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    land_type_show: [],
    project_land_type_show: [],
    type: "area",
    group: "land_area",
  },

  {
    id: 2,
    label: "Built-up",
    field: "buildup_area",
    unit: "sqft",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    land_type_show: [],
    project_land_type_show: [],
    type: "area",
    group: "land_area",
  },

  {
    id: 11,
    label: "Carpet Area",
    field: "carpet_area",
    unit: "sqft",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    land_type_show: [],
    project_land_type_show: [],
    type: "area",
    group: "land_area",
  },

  {
    id: 3,
    label: "Land Area",
    field: "land_area",
    unit: "sqft",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    land_type_show: [],
    project_land_type_show: [],
    type: "area",
    group: "land_area",
  },

  {
    id: 5,
    label: "Plot Size",
    field: "plot_size",
    unit: "ft",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    land_type_show: [],
    project_land_type_show: [],
    type: "computed",
    group: "land_area",
  },

  // ── Other Property Details ────────────────────────────────────

  {
    id: 6,
    label: "Total Floors",
    field: "total_floors",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    type: "number",
    group: "property",
  },

  {
    id: 7,
    label: "Floor No.",
    field: "property_floor_no",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    type: "number",
    group: "property",
  },

  {
    id: 8,
    label: "Parking",
    field: "parking",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    type: "bool",
    group: "property",
  },

  {
    id: 9,
    label: "Gated",
    field: "gated_community",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    type: "bool",
    group: "property",
  },

  {
    id: 10,
    label: "Corner Plot",
    field: "corner_plot",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    type: "bool",
    group: "property",
  },

  {
    id: 12,
    label: "Address",
    field: "address",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    type: "text",
    group: "property",
  },

  {
    id: 13,
    label: "Address Details / Landmark",
    field: "address_details",
    card_show: [],
    card_land_show: [],
    detail_show: [],
    project_detail_show: [],
    type: "text",
    group: "property",
  },

];

export default propertydetail;
